var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 2.78305C20.9752 2.32645 20.5853 1.97642 20.1291 2.00124C14.296 2.31858 10.299 4.43584 7.64216 7.38338C5.00343 10.3109 3.75047 13.9856 3.25093 17.3313C3.07481 18.5109 3 19.906 3 21.172C3 21.6293 3.37037 22 3.82724 22C4.28412 22 4.65449 21.6293 4.65449 21.172C4.65449 19.9592 4.72682 18.6505 4.88725 17.576C4.9343 17.2609 4.98831 16.9439 5.0498 16.6259H7.82639C11.158 16.6259 14.0775 14.7132 15.3972 11.9023C15.5154 11.6506 15.4743 11.4201 15.3233 11.224C15.1601 11.0121 14.8621 10.845 14.4982 10.845H13.0268C12.5699 10.845 12.1996 10.4743 12.1996 10.017C12.1996 9.55975 12.5699 9.18906 13.0268 9.18906H14.0175C19.2649 9.18906 20.8589 4.91838 21 2.78305Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuill);
export default __webpack_public_path__ + "static/media/quill.b85995aef3b6541fee9ec0e73cc9d2c8.svg";
export { ForwardRef as ReactComponent };